module.exports = __webpack_public_path__ + "5b7ac604117609b14e0eea5e19964e87.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/party-dress-s.png
// module id = 1924
// module chunks = 0